import * as z from "zod";
import type { TFunction } from "i18next";
import { isValidCnpj } from "@shared/utils";

export const createClientSchema = (t: TFunction) =>
  z.object({
    // Dados Gerais
    cnpj: z
      .string()
      .min(1, t("management.clients.validation.cnpjRequired"))
      .regex(
        /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
        t("management.clients.validation.cnpjInvalid"),
      )
      .refine((val) => isValidCnpj(val), {
        message: t("management.clients.validation.cnpjInvalid"),
      }),
    name: z.string().min(1, t("management.clients.validation.companyRequired")),
    fantasyName: z
      .string()
      .min(1, t("management.clients.validation.tradeNameRequired")),
    phone: z
      .string()
      .min(1, t("management.clients.validation.companyPhoneRequired"))
      .regex(
        /^\(\d{2}\) \d{5}-\d{4}$/,
        t("management.clients.validation.telefoneInvalid"),
      ),
    municipalRegistration: z.string().optional(),
    logo: z.any().optional(),

    // Endereço
    address: z.object({
      zipCode: z
        .string()
        .min(1, t("management.clients.validation.zipCodeRequired"))
        .regex(/^\d{5}-\d{3}$/, t("management.clients.validation.zipCodeInvalid")),
      street: z
        .string()
        .min(1, t("management.clients.validation.streetRequired")),
      complement: z.string().optional(),
      neighborhood: z
        .string()
        .min(1, t("management.clients.validation.neighborhoodRequired")),
      number: z.coerce
        .number({
          invalid_type_error: t("management.clients.validation.numberInvalid"),
        })
        .int(t("management.clients.validation.numberInvalid"))
        .min(1, t("management.clients.validation.numberRequired")),
      city: z
        .string()
        .min(1, t("management.clients.validation.cityRequired")),
      state: z
        .string()
        .min(1, t("management.clients.validation.stateRequired")),
      country: z
        .string()
        .min(1, t("management.clients.validation.countryRequired")),
    }),

    // Responsável (opcional)
    responsible: z
      .object({
        name: z
          .string()
          .min(1, t("management.clients.validation.responsibleNameRequired")),
        email: z
          .string()
          .email(t("management.clients.validation.emailInvalid"))
          .min(1, t("management.clients.validation.responsibleEmailRequired")),
        phone: z
          .string()
          .min(
            1,
            t("management.clients.validation.responsiblePhoneRequired"),
          )
          .regex(
            /^\(\d{2}\) \d{5}-\d{4}$/,
            t("management.clients.validation.telefoneInvalid"),
          ),
      })
      .optional(),
  });

export type ClientFormData = z.infer<ReturnType<typeof createClientSchema>>;
